export const ADDRESS_ICONS = {
  imgCake: 'D1WL5gtzsHDBCmgZbLfUb',
  imgMelocoton: 'WBDdGI3DkGd9QCGHjM5Di'
}
